import Splide from '@splidejs/splide';

window.BlockCarousel = () => {    
    return {
        slider: null,
        slides: null,
        carouselInit() {
            let slider = new Splide( this.$el, {
                perPage: 1,
                perMove: 1,
                type: 'fade',
                arrows: false,
                pagination: true,
                autoplay: true,
                easing: 'ease',
                speed: 1200,
            }).mount();

            let slides = slider.Components.Elements.getSlides();
            slider.on('move', function(newIndex, oldIndex) {
                /** check if we're actually able to move slide */
                if(newIndex !== oldIndex) {
                    
                    /** animate out */
                    let outSlide = slides[oldIndex].slide;
                    let inSlide = slides[newIndex].slide;

                        let outTitle = outSlide.querySelector('.slide-title');
                        outTitle.classList.remove('delay-500');
                        outTitle.classList.add('-translate-x-max');

                        let outCta = outSlide.querySelector('.slide-cta');
                        outCta.classList.remove('delay-100');
                        outCta.classList.add('-translate-x-max');

                        let outImage = outSlide.querySelector('.slide-image');
                        outImage.classList.add('max-w-0');
                    

                        let inTitle = inSlide.querySelector('.slide-title');
                        inTitle.classList.add('delay-500');
                        inTitle.classList.remove('-translate-x-max');

                        let inCta = inSlide.querySelector('.slide-cta');
                        inCta.classList.add('delay-100');
                        inCta.classList.remove('-translate-x-max');

                        let inImage = inSlide.querySelector('.slide-image');
                        inImage.classList.add('delay-500');
                        inImage.classList.remove('max-w-0');
                    
                }
            });

            this.slider = slider;

        },
    }
}


// WEBPACK FOOTER //
// ./scripts/blocks/Carousel.js